import { JobsModel } from '../models/Jobs.model';
import { FeedItemDTO } from '../../feedItems/dtos/FeedItem.dto';
import { JobRequestDTO, JobsFeedItemType } from '../infra/types';
import { TagUtil } from '../../tags/utils/TagUtil';

export class JobsUtil {
  public static mapToViewModel(dto: FeedItemDTO<JobsFeedItemType>): JobsModel {
    return {
      id: dto.id,
      headline: dto.headline,
      tagline: dto.tagline,
      coverImage: dto.coverImage,
      body: dto.feedItem.body,
      closing_date: dto.feedItem.closing_date,
      employer: dto.feedItem.employer,
      location: dto.feedItem.location,
      type: dto.feedItem.type,
      external_url: dto.feedItem.external_url,
      contact_info: dto.feedItem.contact_info,
      position: dto.feedItem.position,
      qualifications: dto.feedItem.qualifications,
      responsibilities: dto.feedItem.responsibilities,
      salary: dto.feedItem.salary,
      access: dto.access,
      status: dto.status,
      tags: dto.tags ? dto.tags.map((tag) => TagUtil.mapToViewModel(tag)) : [],
      publishedOn: dto.publishedOn,
      citationRequired: dto.citationRequired,
      recipients: dto.recipients,
      feedType: 'JobItem',
    };
  }

  public static toRequestDTO(model?: JobsModel): JobRequestDTO {
    return {
      id: model ? model.id : undefined,
      body: model ? model.body : '',
      headline: model ? model.headline : '',
      tagline: model ? model.tagline : undefined,
      tags: model ? model.tags : [],
      coverImage: model ? model.coverImage : undefined,
      closing_date: model ? model.closing_date : undefined,
      employer: model ? model.employer : undefined,
      contact_info: model ? model.contact_info : undefined,
      external_url: model ? model.external_url : undefined,
      location: model ? model.location : undefined,
      position: model ? model.position : undefined,
      qualifications: model ? model.qualifications : undefined,
      responsibilities: model ? model.responsibilities : undefined,
      salary: model ? model.salary : undefined,
      type: model ? model.type : undefined,
      citationRequired: model ? model.citationRequired : false,
      status: model ? model.status : 'DRAFT',
    };
  }
}
